<app-header></app-header>
<app-alert-component [isFixed]="true" [isDanger]="true" [message]="errorMessage" [noClose]="true"></app-alert-component>